export default __webpack_public_path__ + "static/media/Results-BrainSuite-Advice-ButtonLess.657ca9d8.svg";